import React, {Component, Fragment} from 'react';
import {withNamespaces} from "react-i18next";
import {withRouter} from "react-router-dom";
import cityObjectApi from "../../../apiV2/cityObjectApi";
import CityObjectDetails from "./components/CityObjectDetails";

class CityObject extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cityObject: null,
        };
    }

    componentDidMount() {
        const {match: {params}} = this.props;
        this.loadData(params.id);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const {match: {params}} = nextProps;
        this.loadData(params.id);
    }

    loadData(id) {
        this.setState({
            cityObject: null,
        }, () => {
            cityObjectApi.publicShow(id).then(result => {
                this.setState({
                    cityObject: result,
                });
            });
        });
    }

    render() {
        const {t} = this.props;

        return (
            <Fragment>
                <div className="content-wrapper">
                    <div className="content-heading">
                        <div className="container">
                            <div className="row">
                                <div className="col-6">
                                    {t('fields.object')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">

                        {this.state.cityObject !== null
                            ? <CityObjectDetails cityObject={this.state.cityObject}/>
                            : <span>{t('form.loading')}</span>
                        }
                    </div>
                </div>
            </Fragment>
        );
    }

}

export default withRouter(withNamespaces('common')(CityObject));